// SkillCard.jsx
import { useState } from 'react';

const SkillCard = ({ name, icon, frameworks, customImg, customIcon }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className={`skill-card ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="skill-card__header">
        <div className="skill-card__icon-wrapper">
          {customImg ? (
            <img src={customImg} alt={name} className="skill-card__custom-icon" />
          ) : customIcon ? (
            <img src={customIcon} alt={name} className="skill-card__custom-icon" />
          ) : (
            <i className={`${icon} skill-card__icon`}></i>
          )}
        </div>
        <div className="skill-card__info">
          <h4 className="skill-card__name">{name}</h4>
        </div>
      </div>
      
      {frameworks && frameworks.length > 0 && (
        <div className="skill-card__frameworks">
          <div className="frameworks__title">Frameworks & Libraries</div>
          <div className="frameworks__list">
            {frameworks.map((framework, idx) => (
              <div key={idx} className="framework">
                <i className={framework.icon}></i>
                <span>{framework.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="skill-card__overlay"></div>
    </div>
  );
};

export default SkillCard;